import _ from 'lodash';

export const OrderServicesConstants = {
    orderableServices: {
        2: {
            str_id: 'fertilization',
            displayOrder: 0,
            isOrderableWithoutAssignedPro: true,
        },
        5: {
            str_id: 'aeration',
            displayOrder: 1,
            isOrderableWithoutAssignedPro: true,
        },
        8: {
            str_id: 'bushtrimming',
            displayOrder: 2,
            isOrderableWithoutAssignedPro: true,
        },
        170: {
            str_id: 'bed_weeding',
            displayOrder: 3,
            isOrderableWithoutAssignedPro: false,
        },
        6: {
            str_id: 'mulching',
            displayOrder: 4,
            isOrderableWithoutAssignedPro: false,
        },
        3: {
            str_id: 'treecare',
            displayOrder: 5,
            isOrderableWithoutAssignedPro: false,
        },
        9: {
            str_id: 'landscaping',
            displayOrder: 6,
            isOrderableWithoutAssignedPro: false,
        },
        10: {
            str_id: 'cleanup_leaves',
            displayOrder: 7,
            isOrderableWithoutAssignedPro: false,
        },
        7: {
            str_id: 'cleanup_spring',
            displayOrder: 8,
            isOrderableWithoutAssignedPro: false,
        },
        18: {
            str_id: 'other',
            displayOrder: 9,
            isOrderableWithoutAssignedPro: false,
        },
    },

    locationsByKey: {
        full_yard: 'Full yard',
        front_yard: 'Front-yard',
        back_yard: 'Backyard',
        left_yard: 'Left side',
        right_yard: 'Right side',
    },

    locations: [
        {
            value: 'full_yard',
            label: 'Full yard',
        },
        {
            value: 'front_yard',
            label: 'Front-yard',
        },
        {
            value: 'back_yard',
            label: 'Backyard',
        },
        {
            value: 'left_yard',
            label: 'Left side',
        },
        {
            value: 'right_yard',
            label: 'Right side',
        },
    ],

    bush_trimming: {
        shrub_trim_count: [
            {
                value: '1_to_5',
                label: '1 to 5',
            },
            {
                value: '6_to_10',
                label: '6 to 10',
            },
            {
                value: '11_to_20',
                label: '11 to 20',
            },
            {
                value: '20_to_30',
                label: '20 to 30',
            },
            {
                value: '30+',
                label: '30+',
            },
        ],

        shrub_height: [
            {
                value: 'less_than_5',
                label: 'Less than 5 feet',
            },
            {
                value: '5_to_10',
                label: '5 to 10 feet',
            },
            {
                value: 'greater_than_10',
                label: 'Taller than 10 feet',
            },
        ],

        cut_amount: [
            {
                value: '1_to_3',
                label: '1 to 3 inches',
            },
            {
                value: 'up_to_6',
                label: 'Up to 6 inches',
            },
            {
                value: 'greater_than_6',
                label: 'More than 6 inches',
            },
        ],
    },
};

export const QuoteFlowerBedWeedingOptions = {
    desiredHaulaway: [
        {
            value: 'haulaway',
            label: 'Yes',
        },
        {
            value: 'bag',
            label: 'No, bag and leave by the curb',
        },
        {
            value: 'mulch',
            label: 'No, mulch them up',
        },
    ],

    desiredHaulawayIq: [
        {
            value: true,
            label: 'Yes',
        },
        {
            value: false,
            label: 'No, bag and leave by the curb',
        },
    ],

    desiredHandling: [
        {
            value: 'organic_materials',
            label: 'Yes, using organic materials',
        },
        {
            value: 'any_materials',
            label: 'Yes, using any type of materials',
        },
        {
            value: 'hand_pull',
            label: 'No, hand pull the weeds',
        },
    ],

    sizes: [
        {
            value: '3ftx8ft',
            label: '3ft x 8ft',
        },
        {
            value: '3ftx10ft',
            label: '3ft x 10ft',
        },
        {
            value: '3ftx12ft',
            label: '3ft x 12ft',
        },
        {
            value: '3ftx16ft',
            label: '3ft x 16ft',
        },
        {
            value: '4ftx8ft',
            label: '4ft x 8ft',
        },
        {
            value: '4ftx10ft',
            label: '4ft x 10ft',
        },
        {
            value: '4ftx12ft',
            label: '4ft x 12ft',
        },
        {
            value: '4ftx16ft',
            label: '4ft x 16ft',
        },
        {
            value: '6ftx8ft',
            label: '6ft x 8ft',
        },
        {
            value: '6ftx10ft',
            label: '6ft x 10ft',
        },
        {
            value: '6ftx12ft',
            label: '6ft x 12ft',
        },
        {
            value: '6ftx16ft',
            label: '6ft x 16ft',
        },
        {
            value: 'custom',
            label: 'Custom',
        },
    ],

    locations: [
        {
            value: 'front',
            label: 'Front-yard',
        },
        {
            value: 'back',
            label: 'Backyard',
        },
        {
            value: 'left',
            label: 'Left side',
        },
        {
            value: 'right',
            label: 'Right side',
        },
    ],

    parsedSizes: [
        {
            value: '3ftx8ft',
            label: "3' x 8'",
        },
        {
            value: '3ftx10ft',
            label: "3' x 10'",
        },
        {
            value: '3ftx12ft',
            label: "3' x 12'",
        },
        {
            value: '3ftx16ft',
            label: "3' x 16'",
        },
        {
            value: '4ftx8ft',
            label: "4' x 8'",
        },
        {
            value: '4ftx10ft',
            label: "4' x 10'",
        },
        {
            value: '4ftx12ft',
            label: "4' x 12'",
        },
        {
            value: '4ftx16ft',
            label: "4' x 16'",
        },
        {
            value: '6ftx8ft',
            label: "6' x 8'",
        },
        {
            value: '6ftx10ft',
            label: "6' x 10'",
        },
        {
            value: '6ftx12ft',
            label: "6' x 12'",
        },
        {
            value: '6ftx16ft',
            label: "6' x 16'",
        },
        {
            value: 'custom',
            label: 'Custom',
        },
    ],
};

export const QuoteMulchingOptions = {
    desiredSheeting: [
        {
            value: 'fabric',
            label: 'Yes, using fabric',
        },
        {
            value: 'cardboard',
            label: 'Yes, using cardboard',
        },
        {
            value: 'plastic',
            label: 'Yes, using plastic',
        },
        {
            value: 'newspaper',
            label: 'Yes, using newspaper',
        },
        {
            value: 'none',
            label: 'No, I do not need sheeting',
        },
    ],

    desiredType: [
        {
            value: 'wood',
            label: 'Wood mulch',
        },
        {
            value: 'rubber',
            label: 'Rubber mulch',
        },
        {
            value: 'pine_straw',
            label: 'Pine Straw mulch',
        },
        {
            value: 'other',
            label: 'Other (please specify)',
        },
    ],

    desiredColor: [
        {
            value: 'black',
            label: 'Black',
        },
        {
            value: 'brown',
            label: 'Brown',
        },
        {
            value: 'red',
            label: 'Red',
        },
    ],

    removeMulch: [
        {
            value: true,
            label: 'Yes, remove old mulch and replace with new mulch',
        },
        {
            value: false,
            label: 'No, cover old mulch with new mulch (Recommended)',
        },
    ],

    haulMulch: [
        {
            value: true,
            label: 'Yes',
        },
        {
            value: false,
            label: 'No, bag the old mulch',
        },
    ],

    selfPurchaseMaterials: [
        {
            value: true,
            label: 'Yes, I will buy mulch and sheeting material myself',
        },
        {
            value: false,
            label: 'No, crew needs to buy mulch and sheeting material',
        },
    ],

    sizes: [
        {
            value: '3ftx8ft',
            label: '3ft x 8ft',
        },
        {
            value: '3ftx10ft',
            label: '3ft x 10ft',
        },
        {
            value: '3ftx12ft',
            label: '3ft x 12ft',
        },
        {
            value: '3ftx16ft',
            label: '3ft x 16ft',
        },
        {
            value: '4ftx8ft',
            label: '4ft x 8ft',
        },
        {
            value: '4ftx10ft',
            label: '4ft x 10ft',
        },
        {
            value: '4ftx12ft',
            label: '4ft x 12ft',
        },
        {
            value: '4ftx16ft',
            label: '4ft x 16ft',
        },
        {
            value: '6ftx8ft',
            label: '6ft x 8ft',
        },
        {
            value: '6ftx10ft',
            label: '6ft x 10ft',
        },
        {
            value: '6ftx12ft',
            label: '6ft x 12ft',
        },
        {
            value: '6ftx16ft',
            label: '6ft x 16ft',
        },
        {
            value: 'custom',
            label: 'Custom',
        },
    ],

    locations: [
        {
            value: 'front',
            label: 'Front-yard',
        },
        {
            value: 'back',
            label: 'Backyard',
        },
        {
            value: 'left',
            label: 'Left side',
        },
        {
            value: 'right',
            label: 'Right side',
        },
    ],
};

export const QuoteLeafRemovalOptions = {
    desired_bed_cleanup: [
        {
            value: true,
            label: 'Yes, remove leaves and debris from flower beds',
        },
        {
            value: false,
            label: 'No, I do not need leaves and debris removed from flower beds',
        },
    ],
    debrisTypes: [
        {
            value: 'has_dry_leaves',
            label: 'Dry leaves',
        },
        {
            value: 'has_wet_leaves',
            label: 'Wet leaves',
        },
        {
            value: 'has_fallen_limbs',
            label: 'Fallen limbs, twigs, and branches',
        },
        {
            value: 'has_cut_limbs',
            label: 'Cut limbs, twigs, and branches',
        },
        {
            value: 'has_rocks',
            label: 'Rocks and stones',
        },
        {
            value: 'has_mulch',
            label: 'Mulch',
        },
        {
            value: 'has_pine',
            label: 'Pine leaves and/or pine straw',
        },
        {
            value: 'has_pet_waste',
            label: 'Pet waste',
        },
        {
            value: 'has_other',
            label: 'Other',
        },
    ],
    debrisTypesIq: [
        {
            value: 'has_dry_leaves',
            label: 'Dry leaves',
        },
        {
            value: 'has_wet_leaves',
            label: 'Wet leaves',
        },
        {
            value: 'has_fallen_limbs',
            label: 'Fallen limbs, twigs, and branches',
        },
        {
            value: 'has_cut_limbs',
            label: 'Cut limbs, twigs, and branches',
        },
        {
            value: 'has_rocks',
            label: 'Rocks and stones',
        },
        {
            value: 'has_mulch',
            label: 'Mulch',
        },
        {
            value: 'has_pine',
            label: 'Pine leaves and/or pine straw',
        },
        {
            value: 'has_pet_waste',
            label: 'Pet waste',
        },
        {
            value: 'has_cement',
            label: 'Cement',
        },
        {
            value: 'has_acorns',
            label: 'Acorns',
        },
        {
            value: 'has_pine_cones',
            label: 'Pine cones',
        },
        {
            value: 'has_other',
            label: 'Other',
        },
    ],
    desired_haulaway: [
        {
            value: true,
            label: 'Yes (Recommended)',
        },
        {
            value: false,
            label: 'No, leave the debris at the curb in bags and do not haul it away',
        },
    ],
    last_service: [
        {
            value: '1_to_2_weeks',
            label: '1-2 weeks ago',
        },
        {
            value: '2_to_4_weeks',
            label: '2-4 weeks ago',
        },
        {
            value: '4_to_8_weeks',
            label: '4-8 weeks ago',
        },
        {
            value: '8_to_12_weeks',
            label: '8-12 weeks ago',
        },
        {
            value: '3_to_6_months',
            label: '3-6 months ago',
        },
        {
            value: '6_to_12_months',
            label: '6 months - 1 year ago',
        },
        {
            value: 'over_12_months',
            label: 'More than 1 year ago',
        },
        {
            value: 'unknown',
            label: 'I do not know when I had leaf removal done',
        },
    ],
};

export const QuoteCleanupOptions = {
    desired_bed_cleanup: [
        {
            value: true,
            label: 'Yes, cleanup flower beds',
        },
        {
            value: false,
            label: 'No, I do not need flower beds cleaned up',
        },
    ],
    debrisTypes: [
        {
            value: 'has_weeds',
            label: 'Weeds',
        },
        {
            value: 'has_dry_leaves',
            label: 'Dry leaves',
        },
        {
            value: 'has_wet_leaves',
            label: 'Wet leaves',
        },
        {
            value: 'has_fallen_limbs',
            label: 'Fallen limbs, twigs, and branches',
        },
        {
            value: 'has_cut_limbs',
            label: 'Cut limbs, twigs, and branches',
        },
        {
            value: 'has_rocks',
            label: 'Rocks and stones',
        },
        {
            value: 'has_mulch',
            label: 'Mulch',
        },
        {
            value: 'has_pine',
            label: 'Pine leaves and/or pine straw',
        },
        {
            value: 'has_pet_waste',
            label: 'Pet waste',
        },
        {
            value: 'has_equipment',
            label: 'Appliances/Equipment',
        },
        {
            value: 'has_other',
            label: 'Other',
        },
    ],
    desired_haulaway: [
        {
            value: true,
            label: 'Yes (Recommended)',
        },
        {
            value: false,
            label: 'No, leave the debris at the curb and do not haul it away',
        },
    ],
    last_service: [
        {
            value: '1_to_2_weeks',
            label: '1-2 weeks ago',
        },
        {
            value: '2_to_4_weeks',
            label: '2-4 weeks ago',
        },
        {
            value: '4_to_8_weeks',
            label: '4-8 weeks ago',
        },
        {
            value: '8_to_12_weeks',
            label: '8-12 weeks ago',
        },
        {
            value: '3_to_6_months',
            label: '3-6 months ago',
        },
        {
            value: '6_to_12_months',
            label: '6 months - 1 year ago',
        },
        {
            value: 'over_12_months',
            label: 'More than 1 year ago',
        },
        {
            value: 'unknown',
            label: 'I do not know when I had cleanup done',
        },
    ],
};

export const InstantQuoteConstants = {
    cycleOptions: [
        {
            value: 0,
            label: 'One-Time',
        },
        {
            value: 14,
            label: 'Bi-Weekly',
        },
        {
            value: 28,
            label: 'Monthly (Recommended)',
            default: true,
        },
        {
            value: 56,
            label: 'Bi-Monthly',
        },
        {
            value: 84,
            label: 'Quarterly',
        },
    ],
};

export const InstantQuoteBushTrimmingConstants = {
    locations: [
        {
            value: 'bushes_property_location_full',
            label: 'Full yard',
        },
        {
            value: 'bushes_property_location_front',
            label: 'Front-yard',
        },
        {
            value: 'bushes_property_location_back',
            label: 'Backyard',
        },
        {
            value: 'bushes_property_location_left',
            label: 'Left side',
        },
        {
            value: 'bushes_property_location_right',
            label: 'Right side',
        },
    ],

    shrubTrimCounts: _.map(_.range(31), (num) => {
        return { label: _.toString(num), value: num };
    }),

    locationsByKey: {
        bushes_property_location_full: 'full',
        bushes_property_location_front: 'front',
        bushes_property_location_back: 'back',
        bushes_property_location_left: 'left',
        bushes_property_location_right: 'right',
    },
    desired_clippings_haulaway: [
        {
            value: true,
            label: 'Yes',
        },
        {
            value: false,
            label: 'No',
        },
    ],
};

export const RecommendationBushTrimmingConstants = {
    shrubTrimOptions: [
        {
            value: 'bushes_0ft_5ft_count',
            label: 'Number of shrubs and hedges under 5ft',
        },
        {
            value: 'bushes_5ft_10ft_count',
            label: 'Number of shrubs and hedges between 5ft and 10ft',
        },
        {
            value: 'bushes_over_10ft_count',
            label: 'Number of shrubs and hedges over 10ft',
        },
    ],

    shrubTrimCounts: _.map(_.range(31), (num) => {
        return { label: _.toString(num), value: num };
    }),

    desired_haulaway: [
        {
            value: true,
            label: 'Yes',
        },
        {
            value: false,
            label: 'No',
        },
    ],
};

export const oneTimeServiceDayChangeReasons = [
    {
        label: 'Event',
        value: 'event',
    },
    {
        label: "Original day doesn't work this week",
        value: 'original_day_does_not_work',
    },
    {
        label: 'Having rescheduling issues',
        value: 'rescheduling_issues',
    },
    {
        label: 'Other',
        value: 'other',
    },
];

export const DayToNumberMap = {
    sunday: 0,
    monday: 1,
    tuesday: 2,
    wednesday: 3,
    thursday: 4,
    friday: 5,
    saturday: 6,
};

export const changeMyProReasons = [
    {
        key: 1,
        label: 'Incomplete job',
        value: 'customer.job.incomplete',
    },
    {
        key: 2,
        label: 'Property damage',
        value: 'customer.property.damage',
    },
    {
        key: 3,
        label: 'Quality issue',
        value: 'customer.quality.issue',
    },
    {
        key: 4,
        label: 'Scheduling issue',
        value: 'customer.scheduling.issue',
    },
    {
        key: 5,
        label: 'Other',
        value: 'customer.other',
    },
];

export * from './longGrass';
